import { useAuditApi } from './common/auditApi';

export function useProductionOrderAuditApi() {
  return useAuditApi({
    url: 'productionorder',
    translateTitle: (t) => t.audit.actions.fetchProductionOrder.title,
    translateError: (t) => t.audit.actions.fetchProductionOrder.error,
  });
}
